<template>
  <div
    style="display: flex; justify-content: center !important; align-items: center; width: auto"
  >
    <DxScrollView
      scroll-by-content
      scroll-by-thumb
      direction="both"
    >
      <DxDataGrid
        :data-source="data"
        :allow-column-resazing="true"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="false"
        :column-auto-width="true"
        :row-alternation-enabled="false"
        :word-wrap-enabled="true"
        no-data-text="Sin datos"
        @file-saving="onFileSaving"
      >
        <DxSelection
          mode="single"
        />
        <DxExport
          :enabled="true"
          :texts="{exportAll: 'Exportar',}"
          :file-name="`${resultProject.name} - Abonado - RECOMENDACIONES CONCENTRACIONES NUTRIENTES (PERIODOS 4 SEMANAS)`"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :show-info="true"
          info-text="Página {0} de {1} ({2} periodos)"
          :allowed-page-sizes="['5', '10', '20', '30', '60']"
        />
        <DxHeaderFilter :visible="true" />
        <DxSearchPanel
          :visible="true"
          :width="200"
          :placeholder="$t('Search_placeholder')"
        />
        <DxColumnFixing :enabled="true" />
        <DxColumn
          data-field="date"
          :caption="$t('result.fertigation.date')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="column-center break-word-column"
          :allow-resizing="true"
          :fixed="DEVICE_PLATFORM === 'android' && showColumnByCrop"
          fixed-position="left"
        />
        <DxColumn
          data-field="period"
          :caption="$t('result.fertigation.period')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          :data-field="'soil_needs_N'"
          caption="[N] (mmol/L)"
          :allow-header-filtering="false"
          alignment="left"
          :min-width="100"
        />
        <DxColumn
          v-if="showColumnByCrop"
          :data-field="'soil_needs_P'"
          caption="[P] (mmol/L)"
          :allow-header-filtering="false"
          alignment="left"
          :min-width="100"
        />
        <DxColumn
          v-if="showColumnByCrop"
          :data-field="'soil_needs_K'"
          caption="[K] (mmol/L)"
          :allow-header-filtering="false"
          alignment="left"
          :min-width="100"
        />
        <DxColumn
          v-if="showColumnByCrop"
          :data-field=" 'soil_needs_Ca'"
          caption="[Ca] (mmol/L)"
          :allow-header-filtering="false"
          alignment="left"
          :min-width="100"
        />
        <DxColumn
          v-if="showColumnByCrop"
          :data-field="'soil_needs_Mg'"
          caption="[Mg] (mmol/L)"
          :allow-header-filtering="false"
          alignment="left"
          :min-width="100"
        />
      </DxDataGrid>
    </DxScrollView>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { mapState } from 'vuex';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DEVICE_PLATFORM, TO_FIXED_DECIMALS_IN_TABLES } from '../../js/constants';

export default {
  name: 'ManureResult',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
    DxScrollView,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      TO_FIXED_DECIMALS_IN_TABLES,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    showColumnByCrop() {
      if (this.resultProject && this.resultProject.cultive) {
        switch (this.resultProject.cultive.crop_name) {
          case 'Sandía':
          case 'Berenjena':
          case 'Calabacín':
            return false;
          default:
            return true;
        }
      }
      return true;
    },
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  methods: {
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        const { name } = this.resultProject;
        cordova.plugins.saveDialog.saveFile(e.data, `${this.resultProject.name} - Abonado - RECOMENDACIONES CONCENTRACIONES NUTRIENTES (PERIODOS 4 SEMANAS).xlsx`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
  },
};
</script>
  <style
    lang="scss"
    scoped
  >
    .boton-greenHouse {
    background: #FF7F26;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
    }
    .boton-openAir {
    background: #51A411;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
    }
    .content-checkbox {
    padding-top: 50px;
    padding-left: 40px;
    }
    .content-devx {
        height: 500px !important;
    }
  </style>
